import { AsyncWrapper } from '@mews-commander/ui';
import { usePaymentDetailsSidebarContext } from '../../context/PaymentDetailsSidebarContext';
import { PaymentDetailsSidebarGrid } from '../PaymentDetailsSidebarGrid';
import { BillDetails } from './BillDetails';
import { PaymentPlanDetails } from './PaymentPlanDetails';
import { ReservationsDetails } from './ReservationDetails';

export const RelatedInfoSection = () => {
    const { paymentMethodDetails, isPaymentMethodDetailsError, isPaymentMethodDetailsFetching } =
        usePaymentDetailsSidebarContext();
    if (isPaymentMethodDetailsError) {
        return (
            <>
                <PaymentDetailsSidebarGrid>
                    <BillDetails />
                    <ReservationsDetails />
                </PaymentDetailsSidebarGrid>
                <AsyncWrapper isFetching={false} hasFailed={isPaymentMethodDetailsError}>
                    <PaymentPlanDetails />
                </AsyncWrapper>
            </>
        );
    }

    if (!isPaymentMethodDetailsError && (paymentMethodDetails || isPaymentMethodDetailsFetching)) {
        return (
            <AsyncWrapper isFetching={isPaymentMethodDetailsFetching} hasFailed={false}>
                <PaymentDetailsSidebarGrid>
                    <BillDetails />
                    <ReservationsDetails />
                    <PaymentPlanDetails />
                </PaymentDetailsSidebarGrid>
            </AsyncWrapper>
        );
    }

    return (
        <PaymentDetailsSidebarGrid>
            <BillDetails />
            <ReservationsDetails />
        </PaymentDetailsSidebarGrid>
    );
};
